import settings from '../settings';
import api from './base';

export function getStoryById(id: number) {
  const uri = `${settings.getApiURI()}/story/v1/stories/${id}`;
  return api.http.get(uri);
}
